module.exports = __webpack_public_path__ + "img/title-1.5c7618f8.png";